export enum FindControlDeleteItemStatus {
  Deleted = 'Deleted',
  DeleteFailed = 'DeleteFailed',
  CanBeDeleted = 'CanBeDeleted',
  InUseAndCanBeMerged = 'InUseAndCanBeMerged',
  InUseAndCannotBeDeleted = 'InUseAndCannotBeDeleted',
  MergedNotSupported = 'MergedNotSupported',
  UnknownStatus = 'UnknownStatus',  // UnknownStatus is used to test unknown result return by canDeleteItem endpoint
}
